import type { TranslationKey } from "@veycue/i18n";
import { daysUntil } from "@veycue/shared";
import type { Cue } from "../api/types";
import { useT } from "../state/session";

/**
 * Wiersz Cue. Tytuł powstaje z klucza i18n + parametrów zapisanych przy Cue —
 * backend nigdy nie wysyła gotowego tekstu, więc ta sama baza obsługuje oba języki (§46).
 */
export function CueList({ cues, onSelect }: { cues: readonly Cue[]; onSelect?: (cue: Cue) => void }) {
  const translator = useT();
  const { t } = translator;

  return (
    <div className="cue-list">
      {cues.map((cue) => {
        const days = cue.deadline ? daysUntil(new Date(cue.deadline)) : null;

        return (
          <button
            key={cue.id}
            type="button"
            className="cue"
            data-severity={cue.severity}
            onClick={() => onSelect?.(cue)}
          >
            <span className="cue__head">
              <span className="badge" data-severity={cue.severity}>
                {t(`cue.severity.${cue.severity}` as TranslationKey)}
              </span>
              <span className="cue__title">
                {t(cue.titleKey as TranslationKey, cue.titleParams ?? undefined)}
              </span>
            </span>
            <span className="cue__meta">
              {days === null
                ? t(`cue.status.${cue.status}` as TranslationKey)
                : days >= 0
                  ? t("common.daysRemaining", { count: days })
                  : t("common.daysOverdue", { count: Math.abs(days) })}
            </span>
          </button>
        );
      })}
    </div>
  );
}
